/**
 * Whether two level assignments mean the same thing, compared as sets. A level
 * change is neither an add nor a remove, so without this it would be lost.
 */
export const sameLevels = (
  saved: (number | null)[] | null | undefined,
  next: number[] | undefined
): boolean => {
  const normalize = (value: (number | null)[] | null | undefined): number[] =>
    (value ?? []).filter((level): level is number => !!level).sort();

  const a = normalize(saved);
  const b = normalize(next);
  return a.length === b.length && a.every((level, index) => level === b[index]);
};
